module.exports = __webpack_public_path__ + "static/media/07-links.11cb5db6.png";